export const selectTrajectory = state => state.trajectory;
export default selectTrajectory;
